import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getStockTransfers = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/StockTransfer/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching stock transfers:", error);
    throw error;
  }
};

export const saveStockTransfer = async (stockTransfer) => {
  try {
    console.log('=== API CALL: saveStockTransfer ===');
    console.log('Request payload:', stockTransfer);
    const response = await axios.post(`${BASE_URL}/api/StockTransfer/save`, stockTransfer, {
      headers: getAuthHeader(),
    });
    console.log('=== API RESPONSE ===');
    console.log('Response status:', response.status);
    console.log('Response data:', response.data);
    console.log('Response data keys:', Object.keys(response.data || {}));
    return response.data;
  } catch (error) {
    console.error("=== ERROR IN saveStockTransfer API CALL ===");
    console.error("Error:", error);
    console.error("Error Response:", error.response);
    console.error("Error Data:", error.response?.data);
    throw error;
  }
};

export const getNextTransferNo = async (fromBranchId) => {
  try {
    console.log("=== API CALL: getNextTransferNo ===");
    console.log("Request payload:", { FromBranch_Id: fromBranchId });
    console.log("API URL:", `${BASE_URL}/api/StockTransfer/get-next-transfer-no`);
    
    const payload = {
      FromBranch_Id: fromBranchId
    };
    
    console.log("Sending request with payload:", payload);
    const response = await axios.post(`${BASE_URL}/api/StockTransfer/get-next-transfer-no`, payload, {
      headers: getAuthHeader(),
    });
    
    console.log("API Response status:", response.status);
    console.log("API Response data:", response.data);
    console.log("Response data type:", typeof response.data);
    console.log("Response data keys:", Object.keys(response.data || {}));
    
    return response.data;
  } catch (error) {
    console.error("❌ API Error getting next transfer number:", error);
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    console.error("Error message:", error.message);
    throw error;
  }
};

export const receiveStockTransfer = async (receiveRequest) => {
  try {
    console.log('=== API CALL: receiveStockTransfer ===');
    console.log('Request payload:', receiveRequest);
    
    const response = await axios.post(`${BASE_URL}/api/StockTransfer/receive`, receiveRequest, {
      headers: getAuthHeader(),
    });
    
    console.log('=== API RESPONSE: receiveStockTransfer ===');
    console.log('Response status:', response.status);
    console.log('Response data:', response.data);
    console.log('Response data keys:', Object.keys(response.data || {}));
    
    // Handle tuple response format (Item1, Item2, Item3) or named tuple
    const data = response.data;
    if (data) {
      // Check if it's a tuple format (Item1, Item2, Item3)
      if (data.Item1 !== undefined || data.Item2 !== undefined || data.Item3 !== undefined) {
        return {
          returnedId: data.Item1 || data.returnedId || data.ReturnedId || 0,
          message: data.Item2 || data.message || data.Message || '',
          isSuccess: data.Item3 !== undefined ? data.Item3 : (data.isSuccess !== undefined ? data.isSuccess : (data.IsSuccess !== undefined ? data.IsSuccess : false))
        };
      }
      // Check if it has named properties
      return {
        returnedId: data.returnedId || data.ReturnedId || 0,
        message: data.message || data.Message || '',
        isSuccess: data.isSuccess !== undefined ? data.isSuccess : (data.IsSuccess !== undefined ? data.IsSuccess : false)
      };
    }
    
    return response.data;
  } catch (error) {
    console.error("=== ERROR IN receiveStockTransfer API CALL ===");
    console.error("Error:", error);
    console.error("Error Response:", error.response);
    console.error("Error Data:", error.response?.data);
    throw error;
  }
};

export const getStockForTransfer = async (productId, branchId, businessId = null) => {
  try {
    console.log('=== API CALL: getStockForTransfer ===');
    console.log('Product_Id:', productId, 'Branch_Id:', branchId, 'Business_Id:', businessId);
    
    const payload = {
      Product_Id: productId,
      Branch_Id: branchId,
      Business_Id: businessId
    };
    
    const response = await axios.post(`${BASE_URL}/api/StockTransfer/get-stock-for-transfer`, payload, {
      headers: getAuthHeader(),
    });
    
    console.log('=== API RESPONSE: getStockForTransfer ===');
    console.log('Response status:', response.status);
    console.log('Response data:', response.data);
    
    // Transform the response to match the format expected by StockSelectionModal
    if (response.data && response.data.stockItems) {
      return {
        success: response.data.success !== false,
        stockItems: response.data.stockItems || [],
        hasExpiredStock: response.data.hasExpiredStock || false,
        hasCloseToExpiryStock: response.data.hasCloseToExpiryStock || false,
        totalAvailableStock: response.data.totalAvailableStock || 0,
        message: response.data.message || ''
      };
    }
    
    return response.data;
  } catch (error) {
    console.error("=== ERROR IN getStockForTransfer API CALL ===");
    console.error("Error:", error);
    console.error("Error Response:", error.response);
    console.error("Error Data:", error.response?.data);
    throw error;
  }
};

// API to export stock transfers to Excel (Consolidated)
export const exportStockTransfersToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/StockTransfer/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `StockTransferReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting stock transfers:", error);
    throw error;
  }
};

// API to export individual stock transfer details to Excel
export const exportStockTransferDetailsToExcel = async (stockTransferId) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/StockTransfer/export-details-excel/${stockTransferId}`, {}, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `StockTransferDetails_${stockTransferId}_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting stock transfer details:", error);
    throw error;
  }
};

